(function () {
  var MESSAGE = '© LoveNest - Content is protected';
  var toastTimer = null;

  function showToast() {
    var toast = document.getElementById('lushe-protect-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'lushe-protect-toast';
      toast.textContent = MESSAGE;
      document.body.appendChild(toast);
    }
    toast.classList.add('lushe-protect-toast--visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('lushe-protect-toast--visible');
    }, 2200);
  }

  document.addEventListener('contextmenu', function (event) {
    event.preventDefault();
    showToast();
  });

  document.addEventListener('keydown', function (event) {
    var key = event.key;
    var blocked =
      key === 'F12' ||
      (event.ctrlKey && event.shiftKey && (key === 'I' || key === 'i' || key === 'J' || key === 'j' || key === 'C' || key === 'c')) ||
      (event.ctrlKey && (key === 'U' || key === 'u')) ||
      (event.metaKey && event.altKey && (key === 'I' || key === 'i' || key === 'J' || key === 'j'));
    if (blocked) {
      event.preventDefault();
      showToast();
    }
  });
})();
